import React from 'react';

const NIVEIS = [
  { nivel: 'alta', descricao: 'Prioridade alta' },
  { nivel: 'atencao', descricao: 'Atenção' },
  { nivel: 'estavel', descricao: 'Estável' },
];

const Legenda = () => (
  <div className="legenda">
    <div className="legenda-itens">
      <span className="legenda-titulo">Legenda</span>
      {NIVEIS.map(({ nivel, descricao }) => (
        <div key={nivel} className="legenda-item">
          <span className={'legenda-marcador nivel-' + nivel} />
          {descricao}
        </div>
      ))}
    </div>
  </div>
);

export default Legenda;
